import React from "react";
import { Button, Form, Input, Modal, Select } from "antd";

const CreateUserModal = ({ visible, isLoading, onCancel, onSubmit }) => {
  return (
    <Modal
      title={<span className="user-details-label">Create User 👇</span>}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      maskClosable={false}
    >
      <div className="admin-panel-logout">
        <div className="logout-main-container">
          <Form
            name="create-user"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            initialValues={{
              remember: false,
              role: "employee",
            }}
            onFinish={onSubmit}
            autoComplete="off"
          >
            <p
              style={{
                marginBottom: 16,
                color: "rgba(0,0,0,0.55)",
                fontSize: 13,
              }}
            >
              The user will receive a password-setup email to choose their own
              password and sign in. They can also connect Google or Apple from
              inside the app.
            </p>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your Email!",
                },
                {
                  type: "email",
                  message: "Please enter a valid email address!",
                },
              ]}
              id="email"
            >
              <Input placeholder="name@example.com" />
            </Form.Item>

            <Form.Item
              label="Role"
              name="role"
              id="role"
              rules={[
                {
                  required: true,
                  message: "Please select a role!",
                },
              ]}
            >
              <Select
                options={[
                  { value: "admin", label: "Admin" },
                  { value: "employee", label: "Employee" },
                ]}
              />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
            >
              <Button disabled={isLoading} type="primary" htmlType="submit">
                {isLoading ? "Loading..." : "Submit"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default CreateUserModal;
